export default __webpack_public_path__ + "static/media/HYD-15.a26f5134.webp";